/**
 * QuillForms Depndencies
 */
import { useMessages } from "@quillforms/renderer-core";

/**
 * WordPress Dependencies
 */
import { useEffect, useState } from "react";

/**
 * Internal Dependencies
 */
import ChoicesWrapper from "./choices-wrapper";
import "./style.scss";

let pictureChoiceTimer;
const MultipleChoiceOutput = (props) => {
  const {
    id,
    attributes,
    setIsValid,
    setIsAnswered,
    showNextBtn,
    setValidationErr,
    val,
    setVal,
    next,
    isActive,
    isAnimating,
    showErrMsg,
  } = props;
  const { multiple, required, maxSelection } = attributes;
  const messages = useMessages();
  const [choiceClicked, setChoiceClicked] = useState(null);
  const checkfieldValidation = () => {
    if (required === true && (!val || val.length === 0)) {
      setIsValid(false);
      setValidationErr(messages["label.errorAlert.required"]);
    } else {
      setIsValid(true);
      setValidationErr(null);
    }
  };

  useEffect(() => {
    return () => clearTimeout(pictureChoiceTimer);
  }, []);

  useEffect(() => {
    if (!isActive) {
      clearTimeout(pictureChoiceTimer);
    }
    if (!isActive && !isAnimating) {
      setChoiceClicked(null);
    }
  }, [isActive, isAnimating]);

  useEffect(() => {
    console.log("choiceClicked", choiceClicked);
    console.log("maxSelection", maxSelection);
    clearTimeout(pictureChoiceTimer);
    if (choiceClicked && val?.length > 0 && !multiple) {
      pictureChoiceTimer = setTimeout(() => {
        next();
      }, 600);
    }
    if (choiceClicked && maxSelection === 1) {
      console.log("maxSelection === 1");
      pictureChoiceTimer = setTimeout(() => {
        next();
      }, 600);
    }
  }, [choiceClicked]);

  useEffect(() => {
    checkfieldValidation(val);
  }, [attributes]);

  useEffect(() => {
    checkfieldValidation(val);
    if (val?.length > 0) {
      setIsAnswered(true);
    } else {
      setIsAnswered(false);
    }
    if (multiple) {
      if (val?.length > 0) {
        showNextBtn(true);
      } else {
        showNextBtn(false);
      }
    } else {
      showNextBtn(false);
    }
  }, [val, attributes]);

  return (
    <div className="qf-multiple-choice-block-renderer">
      <ChoicesWrapper
        attributes={attributes}
        id={id}
        val={val}
        setVal={setVal}
        maxSelection={maxSelection}
        setChoiceClicked={(val) => {
          showErrMsg(false);
          setChoiceClicked(val);
        }}
      />
    </div>
  );
};
export default MultipleChoiceOutput;
